<script>

import Layout from "../../layouts/main";
import appConfig from "../../../app.config";
import AccountList from "@/views/energy-conf/account-list.vue";
import i18n from "@/i18n";



export default {
  page: {
    title: i18n.global.t('menu.system-management.user-management'),
    meta: [{
      name: "description",
      content: appConfig.description,
    },],
  },
  data() {
    return {
      title: i18n.global.t('menu.system-management.user-management'),
      items: [{
        text: i18n.global.t('menu.system-management.text'),
        href: "/",
      },
        {
          text: i18n.global.t('menu.system-management.user-management'),
          active: false,
        },
      ],
    }
  },
  components: {
    Layout,
    AccountList,
  },

  methods: {


  },
};
</script>

<template>
  <Layout>
    <account-list
        type="user"
    ></account-list>
  </Layout>

</template>
<style scoped>
.td-min-w {
  min-width: 220px;
}
</style>
